<p-dialog
  [(visible)]="showConfirmationModal"
  [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModal()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ confirmationMessage }}</span>
  </div>
  <ng-template pTemplate="footer">
    
    <p-button
    appPreventDoubleClick
      label="No"
      type="submit"
      icon="pi pi-times"
      id="deletedFilesConfirmationNoButton"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="closeConfirmationModal()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="deletedFilesConfirmationYesButton"
      class="align-right"
      (debounceClick)="confirmation()"
    >
    </p-button>
  </ng-template>
</p-dialog>
